import { t } from 'ember-intl';

import { LayoutSidebarSubnav } from 'core/components';

<template>
  {{#let @controller.model.isEmailPasswordUser as |isEmailPasswordUser|}}
    <LayoutSidebarSubnav @onlySidebar={{true}} as |Subnav|>
      <Subnav.Title>
        {{t "components.page.account-settings.title"}}
      </Subnav.Title>
      <Subnav.Link
        @text={{t "components.page.account-settings.nav.info"}}
        @route="cloud.account-settings.basic-info"
        data-test-account-settings-tabs
      />
      {{#if isEmailPasswordUser}}
        <Subnav.Link
          @text={{t "components.page.account-settings.nav.security"}}
          @route="cloud.account-settings.security"
          data-test-account-settings-tabs
        />
      {{/if}}
      <Subnav.Link
        @text={{t "components.page.account-settings.nav.session-manager"}}
        @route="cloud.account-settings.session-manager"
      />
    </LayoutSidebarSubnav>

    {{outlet}}
  {{/let}}
</template>
